export default {
  // Endpoints
  // Antes decía "/jwt/login", una ruta que no existe: el endpoint real de
  // AuthController::login es "/auth/login" (ver routes/api.php en api-portal-tlv).
  loginEndpoint: "/auth/login",
  registerEndpoint: "/jwt/register",
  refreshEndpoint: "/jwt/refresh-token",
  logoutEndpoint: "/jwt/logout",

  // Magic Link Endpoints
  magicLinkEndpoint: "/auth/magic-link",
  verifyMagicLinkEndpoint: "/auth/verify-magic-link",
  confirmMagicLinkEndpoint: "/auth/confirm-magic-link",

  // SSO desde la app de un integrador externo: canjea el enlace de un solo uso
  partnerSsoEndpoint: "/partner/sso/session",

  // This will be prefixed in authorization header with token
  // e.g. Authorization: Bearer <token>
  tokenType: "Bearer",

  // Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: "accessToken",
  storageRefreshTokenKeyName: "refreshToken",
}
